import CustomerPage from '@/views/pages/customers/customer/index';
import CustomerUsersPage from '@/views/pages/customers/customer/users';
import { Navigate, RouteObject } from 'react-router-dom';
import CustomersPage from '@/views/pages/customers/index';
import SitePage from '@/views/pages/customers/customer/sites/site';
import SitesPage from '@/views/pages/customers/customer/sites/index';
import LocationPage from '@/views/pages/customers/customer/location';
import RolesGuard from '@/router/guards/RolesGuard';
import { Roles } from '@/core/types';
import CustomerDevices from '@/views/pages/customers/customer/devices';

export default [
	{
		path: 'customers',
		element: <RolesGuard roles={[Roles.LEVIANT_ADMIN]} element={<CustomersPage />} />,
	},
	{
		path: 'customers/:customerId',
		element: <RolesGuard roles={[Roles.LEVIANT_ADMIN]} element={<CustomerPage />} />,
		children: [
			{
				path: '',
				element: <Navigate to="site-management" replace={true} />,
			},
			{
				index: true,
				path: 'site-management',
				element: <SitesPage />,
			},
			{
				path: 'devices',
				element: <CustomerDevices />,
			},
			{
				path: 'users',
				element: <CustomerUsersPage />,
			},
		],
	},
	{
		path: 'customers/:customerId/sites/:siteId',
		element: <RolesGuard roles={[Roles.LEVIANT_ADMIN]} element={<SitePage />} />,
	},
	{
		path: 'customers/:customerId/locations/:locationId',
		element: <RolesGuard roles={[Roles.LEVIANT_ADMIN]} element={<LocationPage />} />,
	},
] as RouteObject[];
